import { createAction, handleActions } from "redux-actions";
import * as R from "ramda";
//import * as ThumbInsertTypes from "../db/datafixtures/idx_data_thumb_insert_types";
//import * as InsertTypes from "../db/datafixtures/idx_data_insert_types";
import { idx_data_insert_types } from "../db/datafixtures/idx_data_insert_types.source";
import { idx_data_thumb_insert_types } from "../db/datafixtures/idx_data_thumb_insert_types.source";
const populateInsertOptions = (data, arrayName) => {
  return Object.values(data)
    .filter((insert) =>
      insert.type.toLowerCase().includes(arrayName.toLowerCase())
    )
    .map((insert) => ({
      name: insert.type,
      use: true, // Default value for `use`
    }));
};

export const types = {
  settingsSaveBackup: "SETTINGS_SAVE_BACKUP",
  settingsRestoreBackup: "SETTINGS_RESTORE_BACKUP",
  settingsBackupSaved: "SETTINGS_BACKUP_SAVED",
  settingsBackupNextStep: "SETTINGS_BACKUP_NEXT_STEP",
  settingsBackupDropboxProgress: "SETTINGS_BACKUP_DROPBOX_PROGRESS",
  settingsBackupRestored: "SETTINGS_BACKUP_RESTORED",
  settingsRestoreNextStep: "SETTINGS_RESTORE_NEXT_STEP",
  settingsSetAppSettings: "SETTINGS_SET_APP_SETTINGS",
  settingsHandleForm: "SETTINGS_HANDLE_FORM",
  settingsChangeLanguage: "SETTINGS_CHANGE_LANGUAGE",
  settingsSetLanguage: "SETTINGS_SET_LANGUAGE",
  settingsSaved: "SETTINGS_SAVED",
};

export const settingsSaveBackup = createAction(types.settingsSaveBackup);
export const settingsRestoreBackup = createAction(types.settingsRestoreBackup);
export const settingsBackupSaved = createAction(types.settingsBackupSaved);
export const settingsBackupNextStep = createAction(
  types.settingsBackupNextStep
);
export const settingsBackupDropboxProgress = createAction(
  types.settingsBackupDropboxProgress
);
export const settingsBackupRestored = createAction(
  types.settingsBackupRestored
);
export const settingsRestoreNextStep = createAction(
  types.settingsRestoreNextStep
);
export const settingsSetAppSettings = createAction(
  types.settingsSetAppSettings
);
export const settingsChangeLanguage = createAction(
  types.settingsChangeLanguage
);
export const settingsSetLanguage = createAction(types.settingsSetLanguage);
export const settingsHandleForm = createAction(types.settingsHandleForm);
export const settingsSaved = createAction(types.settingsSaved);

export const INITIAL_STATE = {
  saving: false,
  savingBackup: false,
  backupStep: 1,
  dropboxProgress: {
    progress: 0,
    progressStr: "",
  },
  restoringBackup: false,
  restoreStep: 1,
  language: "en",
  appSettings: {
    systemDefault: {
      default_hand: "right_hander",
      default_ball_grip: "finger_tip",
      angle_measurement: "5",
      display_measurement: "fraction",
      span_measurement: "32",
      pitch_measurement: "32",
      display_f2_span_full_difference: false,
      default_vacu: "std",
      default_vacu_increment: "1/16",
    },
    autoSuggestions: {
      spec_sheet_auto_thumb_pitches: true,
      spec_sheet_auto_lateral_pitches_clt: true,
      spec_sheet_auto_lateral_pitches: true,
      spec_sheet_auto_fill_bridge: true,
      spec_sheet_auto_insert_od: true,
      spec_sheet_auto_repeat_insert_type: true,
      spec_sheet_auto_repeat_insert_size: true,
      spec_sheet_auto_cut_to_cut: false,
      spec_sheet_show_suggested_layouts: false,
      spec_sheet_wizard_offer: true,
    },
    thumbHolePreferences: {
      default_thm_type: "Oval",
      pitch_center_edge: "edge",
      oval_width_difference: "64th",
      pitch_added_to_oval_calculation: false,
      oval_calculation: "trigonometry",
      flip_vh: "vh",
    },
    drillPressCalibration: {
      oval_machine_right_positive: true,
      oval_machine_forward_thumb_positive: true,
      oval_machine_show_pitch_plus_minus: false,
    },
    insertOptions: {
      Vise: [
        ...populateInsertOptions(idx_data_thumb_insert_types, "Vise"),
        ...populateInsertOptions(idx_data_insert_types, "Vise"),
      ],
      Turbo: [
        ...populateInsertOptions(idx_data_thumb_insert_types, "Turbo"),
        ...populateInsertOptions(idx_data_insert_types, "Turbo"),
      ],
      Ultimate: [
        ...populateInsertOptions(idx_data_thumb_insert_types, "Ultimate"),
        ...populateInsertOptions(idx_data_insert_types, "Ultimate"),
      ],
      Contour: [
        ...populateInsertOptions(idx_data_thumb_insert_types, "Contour"),
        ...populateInsertOptions(idx_data_insert_types, "Contour"),
      ],
      Jopo: [
        ...populateInsertOptions(idx_data_thumb_insert_types, "Jopo"),
        ...populateInsertOptions(idx_data_insert_types, "Jopo"),
      ],
    },
    layoutPreferences: {
      arsenal_layout_style: "dual_angle",
      dual_angle_measurement: "5",
    },
    bowlerPreferences: {
      require_email: false,
      require_phone: false,
      // The pro shop's own list of home centers, so a bowler's center is
      // picked from a short list instead of retyped (and misspelt) per client.
      bowling_centers: [],
    },
  },
  driller_name: "",
  driller_email: "",
  driller_email_message: "",
  driller_cc: "",
  customize_list: {
    insert_type: [],
    thumb_insert_type: [],
    ball_manufacturer: [],
  },
  proshop_name: "",
  owner_firstname: "",
  owner_lastname: "",
  owner_email: "",
  owner_password: "",
  owner_password_verification: "",
};

export const settingsReducer = handleActions(
  {
    [types.settingsSaveBackup]: (state) => ({
      ...state,
      savingBackup: true,
    }),
    [types.settingsRestoreBackup]: (state) => ({
      ...state,
      restoringBackup: true,
    }),
    [types.settingsBackupSaved]: (state) => ({
      ...state,
      savingBackup: false,
      backupStep: 1,
    }),
    [types.settingsBackupNextStep]: (state) => ({
      ...state,
      backupStep: state.backupStep + 1,
    }),
    [types.settingsBackupRestored]: (state) => ({
      ...state,
      restoringBackup: false,
      restoreStep: 1,
    }),
    [types.settingsRestoreNextStep]: (state) => ({
      ...state,
      restoreStep: state.restoreStep + 1,
    }),
    [types.settingsHandleForm]: (state, action) => ({
      ...state,
      saving: true,
      appSettings: action.payload?.appSettings || state.appSettings,
    }),
    [types.settingsSetLanguage]: (state, action) => ({
      ...state,
      language: action.payload.language,
    }),
    [types.settingsSetAppSettings]: (state, action) => {
      const pSettings = action.payload.appSettings || {};
      const isTrue = (value, defaultValue = false) => {
        if (value === undefined) return defaultValue;

        return (
          value !== null &&
          (value === true || value === "true" || value === 1 || value === "1")
        );
      };

      // Reconcile a persisted insert-option group against the canonical source
      // list (the default derived from idx_data_insert_types). Using the source
      // as the spine and matching `use` by NAME (not index) means insert types
      // removed from the catalog drop out, newly added types appear with their
      // default `use`, and existing on/off preferences are preserved even when
      // the list order changes.
      const reconcileInsertGroup = (persistedGroup, defaultGroup) => {
        const persistedUse = new Map(
          (persistedGroup || []).map((it) => [it.name, it.use])
        );
        return (defaultGroup || []).map((item) => ({
          ...item,
          use: isTrue(persistedUse.get(item.name), item.use),
        }));
      };

      return {
        ...state,
        language: action.payload.language || state.language,
        appSettings: {
          systemDefault: {
            default_hand:
              pSettings.systemDefault?.default_hand || "right_hander",
            default_ball_grip:
              pSettings.systemDefault?.default_ball_grip || "finger_tip",
            default_ball_grip:
              pSettings.systemDefault?.default_ball_grip || "finger_tip",
            default_vacu: pSettings.systemDefault?.default_vacu || "std",
            default_vacu_increment:
              pSettings.systemDefault?.default_vacu_increment || "1/16",
            angle_measurement:
              pSettings.systemDefault?.angle_measurement || "5",
            display_measurement:
              pSettings.systemDefault?.display_measurement || "fraction",
            span_measurement: pSettings.systemDefault?.span_measurement || "32",
            pitch_measurement:
              pSettings.systemDefault?.pitch_measurement || "32",
            display_f2_span_full_difference: isTrue(
              pSettings.systemDefault?.display_f2_span_full_difference,
              state.appSettings.systemDefault.display_f2_span_full_difference
            ),
            default_vacu: pSettings.systemDefault?.default_vacu || "std",
            default_vacu_increment:
              pSettings.systemDefault?.default_vacu_increment || "1/16",
          },
          autoSuggestions: {
            spec_sheet_auto_thumb_pitches: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_thumb_pitches,
              state.appSettings.autoSuggestions.spec_sheet_auto_thumb_pitches
            ),
            spec_sheet_auto_lateral_pitches_clt: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_lateral_pitches_clt,
              state.appSettings.autoSuggestions
                .spec_sheet_auto_lateral_pitches_clt
            ),
            spec_sheet_auto_lateral_pitches: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_lateral_pitches,
              state.appSettings.autoSuggestions.spec_sheet_auto_lateral_pitches
            ),
            spec_sheet_auto_fill_bridge: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_fill_bridge,
              state.appSettings.autoSuggestions.spec_sheet_auto_fill_bridge
            ),
            spec_sheet_auto_insert_od: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_insert_od,
              state.appSettings.autoSuggestions.spec_sheet_auto_insert_od
            ),
            spec_sheet_auto_repeat_insert_type: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_repeat_insert_type,
              state.appSettings.autoSuggestions
                .spec_sheet_auto_repeat_insert_type
            ),
            spec_sheet_auto_repeat_insert_size: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_repeat_insert_size,
              state.appSettings.autoSuggestions
                .spec_sheet_auto_repeat_insert_size
            ),
            spec_sheet_auto_cut_to_cut: isTrue(
              pSettings.autoSuggestions?.spec_sheet_auto_cut_to_cut,
              state.appSettings.autoSuggestions.spec_sheet_auto_cut_to_cut
            ),
            spec_sheet_show_suggested_layouts: isTrue(
              pSettings.autoSuggestions?.spec_sheet_show_suggested_layouts,
              state.appSettings.autoSuggestions
                .spec_sheet_show_suggested_layouts
            ),
            spec_sheet_wizard_offer: isTrue(
              pSettings.autoSuggestions?.spec_sheet_wizard_offer,
              state.appSettings.autoSuggestions.spec_sheet_wizard_offer
            ),
          },
          thumbHolePreferences: {
            default_thm_type:
              pSettings.thumbHolePreferences?.default_thm_type || "Oval",
            flip_vh: pSettings.thumbHolePreferences?.flip_vh || "vh",
            pitch_center_edge:
              pSettings.thumbHolePreferences?.pitch_center_edge || "edge",
            oval_width_difference:
              pSettings.thumbHolePreferences?.oval_width_difference || "64th",
            pitch_added_to_oval_calculation: isTrue(
              pSettings.thumbHolePreferences?.pitch_added_to_oval_calculation
            ),
            oval_calculation:
              pSettings.thumbHolePreferences?.oval_calculation ||
              "trigonometry",
          },
          drillPressCalibration: {
            oval_machine_right_positive: isTrue(
              pSettings.drillPressCalibration?.oval_machine_right_positive
            ),
            oval_machine_forward_thumb_positive: isTrue(
              pSettings.drillPressCalibration
                ?.oval_machine_forward_thumb_positive
            ),
            oval_machine_show_pitch_plus_minus: isTrue(
              pSettings.drillPressCalibration
                ?.oval_machine_show_pitch_plus_minus
            ),
          },
          insertOptions: {
            Vise: reconcileInsertGroup(
              pSettings.insertOptions?.Vise,
              state.appSettings.insertOptions.Vise
            ),
            Turbo: reconcileInsertGroup(
              pSettings.insertOptions?.Turbo,
              state.appSettings.insertOptions.Turbo
            ),
            Ultimate: reconcileInsertGroup(
              pSettings.insertOptions?.Ultimate,
              state.appSettings.insertOptions.Ultimate
            ),
            Contour: reconcileInsertGroup(
              pSettings.insertOptions?.Contour,
              state.appSettings.insertOptions.Contour
            ),
            Jopo: reconcileInsertGroup(
              pSettings.insertOptions?.Jopo,
              state.appSettings.insertOptions.Jopo
            ),
          },
          layoutPreferences: {
            arsenal_layout_style:
              pSettings.layoutPreferences?.arsenal_layout_style || "dual_angle",
            dual_angle_measurement:
              pSettings.layoutPreferences?.dual_angle_measurement || 5,
          },
          bowlerPreferences: {
            require_email: isTrue(
              pSettings.bowlerPreferences?.require_email,
              state.appSettings.bowlerPreferences.require_email
            ),
            require_phone: isTrue(
              pSettings.bowlerPreferences?.require_phone,
              state.appSettings.bowlerPreferences.require_phone
            ),
            bowling_centers: Array.isArray(
              pSettings.bowlerPreferences?.bowling_centers
            )
              ? pSettings.bowlerPreferences.bowling_centers
              : state.appSettings.bowlerPreferences.bowling_centers || [],
          },
        },
      };
    },
    [types.settingsSaved]: (state) => ({
      ...state,
      saving: false,
    }),
    [types.settingsBackupDropboxProgress]: (state, action) => ({
      ...state,
      dropboxProgress: action.payload.dropboxProgress,
    }),
  },
  INITIAL_STATE
);
